/* eslint-disable react/no-danger */
import React, { useEffect, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import {
  PrivacySettingToggle,
  PrivacySettingToggles,
} from '@prisjakt/web-app-config/types/market';
import { noop } from '@prisjakt/ui-base';
import { AppContext } from '@prisjakt/ui-app-context';
import acceptCookiesAction from '../cookie-banner/actions';
import { AppState } from '../../reducers';

type OwnProps = {};

type StateProps = {
  version: string;
  settings: PrivacySettingToggle;
  isLoggedIn: boolean;
};

type DispatchProps = {
  acceptCookies: (
    version: string,
    settings: PrivacySettingToggle,
    isLoggedIn: boolean
  ) => void;
};

type Props = OwnProps & StateProps & DispatchProps;

const CookieBannerSourcePoint = ({
  acceptCookies = noop,
  settings,
  isLoggedIn,
}: Props) => {
  const { renderMode, market } = useContext(AppContext);
  const privacySettings =
    market &&
    market.privacySettings &&
    (market.privacySettings[renderMode] || market.privacySettings.responsive);

  useEffect(() => {
    if (!IS_BROWSER) {
      return;
    }
    try {
      __tcfapi('addEventListener', 2, (tcData: any, success: any) => {
        if (success && tcData.eventStatus === 'useractioncomplete') {
          onAcceptCookies();
        }
      });
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }, []);

  const onAcceptCookies = useCallback(() => {
    let prisjaktConsent = false;
    __tcfapi('getCustomVendorConsents', 2, (vendorConsents: any) => {
      vendorConsents.consentedVendors.forEach((vendor: any) => {
        if (vendor._id === market?.sourcePointCMP?.priceSpyVendorID) {
          prisjaktConsent = true;
        }
      });
    });

    // BehaviourTrackingImprovement is always true due to us wanting to maintain correct data in GA (this is only for sourcepoint markets)
    // We noticed that our GA showed less traffic than normal after we added Reject All Button on the first layer of the sourcepoint
    // cookie banner. The data is now only used for analysis and not marketing.
    // This is a temporary fix until we have Google Consent Mode setup.
    acceptCookies(
      privacySettings.cookieVersion,
      {
        ...settings,
        [PrivacySettingToggles.BehaviorTrackingMarketing]: prisjaktConsent,
        [PrivacySettingToggles.BehaviorTrackingSurveys]: prisjaktConsent,
        [PrivacySettingToggles.BehaviourTrackingImprovement]: true,
        [PrivacySettingToggles.Personalization]: prisjaktConsent,
        [PrivacySettingToggles.PersonalizedAds]: prisjaktConsent,
      },
      isLoggedIn
    );
  }, [isLoggedIn, privacySettings, acceptCookies, settings]);
  return <div />;
};

const mapStateToProps = (state: AppState) => ({
  version: state.globals.cookieBanner.version,
  settings: state.areas.user.tracking.settings,
  isLoggedIn: state.areas.account.isAuthenticated,
});

const dispatchProps = {
  acceptCookies: acceptCookiesAction,
};

export default connect(mapStateToProps, dispatchProps)(CookieBannerSourcePoint);
